import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 246.3 246.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M122.1 0C8.9 0 0 8.9 0 122.1v2.2c0 113.2 8.9 122.1 122.1 122.1h2.2c113.2 0 122.1-8.9 122.1-122.1v-1.1C246.3 8.9 237.4 0 123.2 0zM98.5 24.6h49.3c68.5 0 73.9 5.4 73.9 73.9v49.3c0 68.5-5.4 73.9-73.9 73.9H98.5c-68.5 0-73.9-5.4-73.9-73.9V98.5c0-68.5 5.4-73.9 73.9-73.9m86.2 24.7c-6.8-.1-12.4 5.3-12.6 12.1-.1 6.8 5.3 12.4 12.1 12.6h.5c6.8-.2 12.2-5.8 12-12.6-.2-6.6-5.5-11.9-12.1-12ZM123 61.6c-34 0-61.5 27.7-61.4 61.7s27.7 61.5 61.7 61.4 61.5-27.7 61.4-61.7S157 61.5 123 61.6m.1 24.6c20.4 0 37 16.5 37 36.9s-16.5 37-36.9 37-37-16.5-37-36.9 16.5-37 36.9-37" }, null, -1)
  ]))]))
}
export default { render: render }